import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export const DevopsRepositoriesIcon = createSvgIcon(
    <svg x="0px" y="0px" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1315.2 978.9" enableBackground="new 0 0 1315.2 978.9" xmlSpace="preserve" >
        <path fill="#BC3618" d="M849,122.7H466.1c-14.7,0-26.6,11.8-26.6,26.5c0,0,0,0.1,0,0.1v87.2h436.2v-87.2c0-14.7-11.8-26.6-26.5-26.6
        C849.1,122.7,849.1,122.7,849,122.7z"/>
        <path fill="#D13816" d="M894.1,176H421.1c-21.2,0-38.5,17.2-38.5,38.4c0,0,0,0.1,0,0.1v30.3h550.1v-30.3c0-21.2-17.2-38.5-38.4-38.5
        C894.2,176,894.2,176,894.1,176z"/>
        <path fill="#E15A18" d="M949.6,230.6h-584c-21.2,0-38.5,17.2-38.5,38.4c0,0,0,0.1,0,0.1v548.4c0,21.3,17.3,38.6,38.7,38.7h583.6
        c21.3,0,38.6-17.3,38.7-38.7V269.1C988.1,247.9,970.9,230.7,949.6,230.6C949.6,230.6,949.6,230.6,949.6,230.6z"/>
        <path fill="#F7B192" d="M522.1,287.1c-40.5,0-73.4,32.9-73.3,73.4s32.9,73.4,73.4,73.3c40.5,0,73.3-32.9,73.3-73.4
        C595.6,320,562.7,287.1,522.1,287.1z M522.1,408c-26.3,0-47.7-21.3-47.7-47.7c0-26.3,21.3-47.7,47.7-47.7
        c26.3,0,47.7,21.3,47.7,47.7C569.8,386.7,548.5,408,522.1,408C522.2,408,522.2,408,522.1,408z"/>
        <path fill="#F7B192" d="M549.7,425.9h-54.4v148.8h54.4V425.9z" />
        <path fill="#FCDACB" d="M870.7,361.5c0-40.5-32.9-73.4-73.4-73.4s-73.4,32.9-73.4,73.4c0,30.4,18.7,57.6,47,68.5v50.4l-275.6,91h-0.5
        v93.3c-37.5,15.2-55.5,57.9-40.3,95.4s57.9,55.5,95.4,40.3c37.5-15.2,55.5-57.9,40.3-95.4c-7.3-18.1-21.6-32.4-39.5-40v-57.8
        l274.1-90.6l-0.6-1.1h0.6v-86.2C852.5,418.3,870.7,391.4,870.7,361.5z M569.8,733c0,26.3-21.3,47.7-47.7,47.7s-47.7-21.3-47.7-47.7
        c0-26.3,21.3-47.7,47.7-47.7c0,0,0,0,0,0C548.5,685.4,569.8,706.7,569.8,733C569.8,733,569.8,733,569.8,733z M797.3,409
        c-26.3,0-47.7-21.3-47.7-47.7c0-26.3,21.3-47.7,47.7-47.7c26.3,0,47.7,21.3,47.7,47.7c0,0,0,0,0,0C845,387.7,823.6,409,797.3,409
        C797.3,409,797.3,409,797.3,409L797.3,409z"/>
    </svg>
    ,
    'Devops Repositories',
);

